export var RankedUserStateType = /*#__PURE__*/ function(RankedUserStateType) {
    RankedUserStateType[RankedUserStateType["Placement"] = 0] = "Placement";
    RankedUserStateType[RankedUserStateType["Ranked"] = 1] = "Ranked";
    RankedUserStateType[RankedUserStateType["RankedLocked"] = 2] = "RankedLocked";
    return RankedUserStateType;
}({});
export class BaseRankedUserState {
}
